import {
  CreateAccountModel,
} from 'src/app/Elearning-Models';

export class CreateAccountServiceMockValues {
  public userData: CreateAccountModel = {
    FirstName: 'Fran',
      LastName: 'Ayala',
      Email: 'f.ayala@gmail.com',
      UserID: 1,
  }

}

